import { ReactSVG } from "react-svg";

const Card = ({ data, handleNavigate }) => {
  return (
    <button
      onClick={handleNavigate}
      className="flex flex-col items-center gap-[13px] disabled:cursor-not-allowed"
      key={data?.id}
    >
      <div
        className="size-[62px] rounded-full flex justify-center items-center bg-[#1111110D]"
        
      >
        <div className="">
          <ReactSVG src={data.icon} />
        </div>
      </div>
      <h3 className="font-semibold text-gray text-[13px]">
        {data.name}
      </h3>
    </button>
  );
};

export default Card;
